module.exports = __webpack_public_path__ + "static/media/s5.106c85fe.png";